import styled, { CSSProperties } from 'styled-components'

export const TooltipWrapper = styled.div<{
  $noPadding?: boolean
  $opacity?: CSSProperties['opacity']
  $maxWidth?: CSSProperties['maxWidth']
}>`
  position: fixed;
  z-index: 99999;

  border-radius: 8px;
  width: fit-content;
  max-width: ${({ $maxWidth }) => $maxWidth ?? '99vw'};
  padding: ${({ $noPadding }) => ($noPadding ? 0 : '8px 16px')};

  &:before {
    content: '';

    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;

    border-radius: inherit;
    width: 100%;
    height: 100%;

    background-color: var(--gray-800);
    opacity: ${({ $opacity }) => $opacity ?? 0.8};
  }
`

export const TooltipText = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;

  border-radius: 4px;

  & > h1,
  & > p,
  & > span {
    margin: 0;
    line-height: 1.5;
    font-size: 12px;
    white-space: pre-wrap;
    align-content: center;
    color: var(--gray-0);
  }

  h1 {
    font-weight: 600;
  }

  p {
    font-weight: 400;
  }

  .inline {
    display: inline-flex;
    gap: 0px;
  }
`

export const ArrowWrapper = styled.div.attrs((props) => ({ ...props, id: 'arrow' }))`
  position: absolute;
  z-index: -1;

  opacity: 0.8;
  background-color: var(--gray-800);

  clip-path: polygon(100% 0%, 50% 100%, 0% 0%);
`

export const TooltipTriggerContainer = styled.span`
  display: block;
`
